import { Typography, Box } from '@material-ui/core';
import React, { useState } from 'react';
import css from './styles.module.scss';
import classNames from 'classnames';
import Drawer from '@material-ui/core/Drawer';
import Divider from '@material-ui/core/Divider';
import { RightDrawer } from '../right-drawer';

interface PageTitleProps {
    subtitle?: string | null;
    className?: string;
    noBorder?: boolean;
}

export const PageTitle: React.FC<PageTitleProps> = ({ className, children, subtitle, noBorder = false }) => {
    const [openDrawer, setOpenDrawer] = useState(false);
    return (
        <div className={classNames(css.module, className, !noBorder && 'border')}>
            <Typography className={css.title} variant={'h5'}>
                {children}
            </Typography>
            {/* {subtitle && (
                <Typography variant={'subtitle2'} className={css.subtitle}>
                    {subtitle}
                </Typography>
            )} */}

            <Drawer anchor={`right`} open={openDrawer} className={css.rightdrawer}>
                <Typography className={css.closedrawer} onClick={() => setOpenDrawer(false)}>
                    <Box component="span" fontSize={40}>
                        &larr;
                    </Box>
                    <Box component="span" fontSize={15} className={css.closetitle}>
                        Close
                    </Box>
                </Typography>
                <Divider />

                <RightDrawer />
            </Drawer>
        </div>
    );
};
